<!-- Loading State -->
<div class="min-h-screen flex items-center justify-center bg-base-200 p-8">
	<div class="bg-base-100 rounded-lg shadow-lg p-8 max-w-md w-full text-center">

        <!-- Crust Logo -->
		<div class="mb-4">
			<crust-logo [color]="'#202620'" [size]="'h-8 w-auto mx-auto'"></crust-logo>
		</div>

        <img 
		src="assets/images/ui/loading-sm.gif" 
		alt="Loading"
		class="w-auto h-auto mx-auto"
        />


	</div>
</div>
